function Test() {
    return <h1 className="title">Hello World</h1>
}

export default Test
